// extracted by mini-css-extract-plugin
module.exports = {"image":"_2QFGV","heading":"_22yjB","subheading":"_2lnH6","description":"_1B2Lb","button":"_3bCz6"};